/**
 * Hook to handle smooth scrolling to sections
 * @param {number} offset - Offset from the top of the section (e.g., for fixed headers)
 * @returns {Function} - Function to scroll to a section by ID
 */
const useSmoothScroll = (offset = 0) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(`${sectionId}-section`);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return scrollToSection;
};

export default useSmoothScroll; 